import { BFF_BASE_URL } from "../../../api/client";

/**
 * Opens the CAC VSC/GAP forms for the given approval in a new browser tab
 * (GET /api/v1/workbench/{appId}/cac-ancillary-forms/pdf). The BFF asks CAPS to regenerate the
 * forms and returns them merged into a single PDF with `Content-Disposition: inline`, so the
 * browser renders it directly; auth rides on the same-origin session cookie.
 * @param {string} approvalId - The approval/deal ID.
 */
export function printCacVscGapForms(approvalId: string): void {
  const url = `${BFF_BASE_URL}/api/v1/workbench/${encodeURIComponent(approvalId)}/cac-ancillary-forms/pdf`;
  window.open(url, "_blank");
}
